import { isFreeEmail } from "free-email-domains-list"

/**
 * Returns true if the email's domain is a known freemail/consumer provider.
 * Uses the free-email-domains-list package (updated weekly, 3000+ domains).
 * @param {string} email
 * @returns {boolean}
 */
export function isFreemailDomain(email) {
  return isFreeEmail(email.toLowerCase())
}
